/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleSearchConsoleBrandPreviewInput
 */
export interface GoogleSearchConsoleBrandPreviewInput {
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleBrandPreviewInput
     */
    since?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleBrandPreviewInput
     */
    until?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GoogleSearchConsoleBrandPreviewInput
     */
    effectiveFrom?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof GoogleSearchConsoleBrandPreviewInput
     */
    terms?: Array<string>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleBrandPreviewInput interface.
 */
export function instanceOfGoogleSearchConsoleBrandPreviewInput(value: object): value is GoogleSearchConsoleBrandPreviewInput {
    return true;
}

export function GoogleSearchConsoleBrandPreviewInputFromJSON(json: any): GoogleSearchConsoleBrandPreviewInput {
    return GoogleSearchConsoleBrandPreviewInputFromJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandPreviewInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleBrandPreviewInput {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : (new Date(json['since'])),
        'until': json['until'] == null ? undefined : (new Date(json['until'])),
        'effectiveFrom': json['effectiveFrom'] == null ? undefined : (new Date(json['effectiveFrom'])),
        'terms': json['terms'] == null ? undefined : json['terms'],
    };
}

export function GoogleSearchConsoleBrandPreviewInputToJSON(json: any): GoogleSearchConsoleBrandPreviewInput {
    return GoogleSearchConsoleBrandPreviewInputToJSONTyped(json, false);
}

export function GoogleSearchConsoleBrandPreviewInputToJSONTyped(value?: GoogleSearchConsoleBrandPreviewInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'] == null ? value['since'] : value['since'].toISOString().substring(0,10),
        'until': value['until'] == null ? value['until'] : value['until'].toISOString().substring(0,10),
        'effectiveFrom': value['effectiveFrom'] == null ? value['effectiveFrom'] : value['effectiveFrom'].toISOString().substring(0,10),
        'terms': value['terms'],
    };
}

